import LegalCareersBlock from './LegalCareersBlock'
import LegalCareersCardBlock from './LegalCareersCardBlock'

export { LegalCareersBlock, LegalCareersCardBlock }
